import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import AppBar from "../../components/DefaultAppBar";
import DocumentSearchInput from "./components/DocumentSearch";
import DocumentsExpansionPanel from "./components/ExpansionPanels";
import DocumentFolderList from "./components/DocumentFolderList";

import LocationFilterToolbar from "../../App/LocationFilterToolbar";

import {
  fetchDocumentCategoriesThunk,
  fetchDocumentsThunk,
} from "../../modules/documents/documentOperations";
import { documentSelectors } from "../../modules/documents/documentsSlice";
import { documentCategorySelectors } from "../../modules/documents/documentCategoriesSlice";
import { Box } from "@mui/material";
import DocumentLayout from "../../components/Layouts/DocumentLayout";

export const route = "/documents";

function DocumentListContainer() {
  const documents = useSelector(documentSelectors.selectAll);
  const documentCategories = useSelector(documentCategorySelectors.selectAll);
  const documentTextSearch = useSelector(documentSelectors.selectTextSearch);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDocumentCategoriesThunk());
    dispatch(fetchDocumentsThunk());
  }, [dispatch]);

  return (
    <>
      <AppBar>
        <LocationFilterToolbar />
      </AppBar>

      <DocumentLayout>
        <Box sx={{ py: 3 }}>
          <DocumentSearchInput />
          <Box sx={{ mt: 2 }}>
            {documentTextSearch.length ? (
              <DocumentFolderList data={documents} />
            ) : (
              <DocumentsExpansionPanel
                primary={documentCategories}
                secondary={documents}
              />
            )}
          </Box>
        </Box>
      </DocumentLayout>
    </>
  );
}

DocumentListContainer.route = route;

export default DocumentListContainer;
